import script from "./Delete.vue?vue&type=script&setup=true&lang=js"
export * from "./Delete.vue?vue&type=script&setup=true&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=2263011c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2263011c"]])

export default __exports__